// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AlBeiCgMZKk2ZSZikGM_{margin-left:20px;margin-right:20px}.R2QITzsJA_YK2ybFsxDv{background:var(--border-neutral-default);width:calc(100% - 40px);height:1px;margin:16px 20px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `AlBeiCgMZKk2ZSZikGM_`,
	"separator": `R2QITzsJA_YK2ybFsxDv`
};
export default ___CSS_LOADER_EXPORT___;
